import { Route } from '@angular/router';
import { AppUrls } from '../../../../../../common/dto/app-urls';

export const VisitorsRoute: Route = {
  path: AppUrls.Dashboard._.Discover._.Visitors.relativeUrl,
  loadComponent: () => import('./visitors.component').then(_ => _.VisitorsComponent),
};
